import { AxiosPromise } from "axios";
import { DiningRDCommunityDto, DrdResourceApi } from "../generated/dashboard-client";
import { dashboardApiConfig, ops } from "./config";

const api = new DrdResourceApi(dashboardApiConfig);

const DRDApi = {
  getCommunities(): AxiosPromise<DiningRDCommunityDto[]> {
    return api.getCommunities(ops());
  },

  updateCommunity(dto: DiningRDCommunityDto): AxiosPromise<DiningRDCommunityDto> {
    if (!dto.id) return Promise.reject("Missing id");
    return api.updateCommunity(dto.id, dto, ops());
  },

  createCommunity(dto: DiningRDCommunityDto): AxiosPromise<DiningRDCommunityDto> {
    if (!dto.name || !dto.memberId || !dto.locationId || !dto.id) return Promise.reject({response: "Missing id"});
    return api.createCommunity(dto, ops());
  },

  deleteCommunity(id: number): AxiosPromise<void> {
    return api.deleteCommunity(id, ops());
  }
};

export default DRDApi;
